import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getEnterpriseView = createAsyncThunk(
  "enterprise/getEnterpriseView",
  async (statusId) => {
    const formattedStatusId = Array.isArray(statusId) ? statusId.join(",") : statusId;
    const response = await axios.get(
      `/api/admin/getEnterprise?statusId=${formattedStatusId}`,
    );
    return response.response;
  },
);

export const addNewEnterprise = createAsyncThunk(
  "enterprise/addNewEnterprise",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/admin/addNewEnterprise",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const entDocs = createAsyncThunk(
  "enterprise/entDocs",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/entDocs", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const deactivateEnt = createAsyncThunk(
  "enterprise/deactivateEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/deactivateEnt`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const activateEnt = createAsyncThunk(
  "enterprise/activateEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/activateEnt`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const blacklistEnt = createAsyncThunk(
  "enterprise/blacklistEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/blacklistEnt`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const getApproveEnt = createAsyncThunk(
  "enterprise/getApproveEnt",
  async (entId) => {
    const response = await axios.get(`/api/admin/getApproveEnt?entId=${entId}`);
    return response.response;
  },
);

export const verifyEntPan = createAsyncThunk(
  "enterprise/verifyEntPan",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/verifyEntPan`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const verifyEntGstin = createAsyncThunk(
  "enterprise/verifyEntGstin",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/verifyEntGstin`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const approveEnt = createAsyncThunk(
  "enterprise/approveEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/approveEnt", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const verifyDoc = createAsyncThunk(
  "enterprise/verifyDoc",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/verifyDoc`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const rejectDoc = createAsyncThunk(
  "enterprise/rejectDoc",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/rejectDoc`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const reUploadEntDocs = createAsyncThunk(
  "enterprise/reUploadEntDocs",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/reUploadEntDocs`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const entDetailedView = createAsyncThunk(
  "enterprise/entDetailedView",
  async (entId) => {
    const response = await axios.get(
      `/api/admin/getEntDetailedView?entId=${entId}`,
    );
    return response.response;
  },
);

export const getDesignations = createAsyncThunk(
  "enterprise/getDesignations",
  async () => {
    const response = await axios.get(`/api/admin/getDesignations`);
    return response.response;
  },
);

export const getTags = createAsyncThunk("enterprise/getTags", async () => {
  const response = await axios.get(`/api/admin/getTags`);
  return response.response;
});

export const editEntDets = createAsyncThunk(
  "enterprise/editEntDets",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/editEntDets", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const getAllRating = createAsyncThunk(
  "enterprise/getAllRating",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getAllRating");
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const financialDocUpload = createAsyncThunk(
  "enquiryManagement/financialDocUpload",
  async ({ entId, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/financialDocUpload?entId=${entId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const getAllStates = createAsyncThunk(
  "enterprise/getAllStates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getAllStates");
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const getEnterprisePocs = createAsyncThunk(
  "enterprise/getEnterprisePocs",
  async (
    { entId, department, approvalStatus, apob, search, page = 1, limit = 10 },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();
      if (department) params.append("department", department);
      if (approvalStatus) params.append("approvalStatus", approvalStatus);
      if (approvalStatus === "DELETED") {
        params.append("onlyDeleted", "true");
        params.append("includeDeleted", "true");
      }
      if (apob) params.append("apob", apob);
      if (search) params.append("search", search);
      if (page) params.append("page", page);
      if (limit) params.append("limit", limit);

      const response = await axios.get(
        `/api/admin/v1/enterprise/${entId}/pocs?${params.toString()}`
      );
      return response.response || response.data || response;
    } catch (err) {
      return rejectWithValue(err || "Failed to fetch Enterprise POCs");
    }
  }
);

export const checkEnterprisePocEmail = createAsyncThunk(
  "enterprise/checkEnterprisePocEmail",
  async ({ entId, email, excludePocId }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      params.append("email", email);
      if (excludePocId) params.append("excludePocId", excludePocId);

      const response = await axios.get(
        `/api/admin/v1/enterprise/${entId}/pocs/check-email?${params.toString()}`
      );
      return response.response || response.data || response;
    } catch (err) {
      return rejectWithValue(err || "Failed to check POC email");
    }
  }
);

export const addEnterprisePoc = createAsyncThunk(
  "enterprise/addEnterprisePoc",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/v1/enterprise/poc", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to add Enterprise POC");
    }
  }
);

export const updateEnterprisePoc = createAsyncThunk(
  "enterprise/updateEnterprisePoc",
  async ({ pocId, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `/api/admin/v1/enterprise/poc/${pocId}`,
        data
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to update Enterprise POC");
    }
  }
);

export const deleteEnterprisePoc = createAsyncThunk(
  "enterprise/deleteEnterprisePoc",
  async (pocId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `/api/admin/v1/enterprise/poc/${pocId}`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to delete Enterprise POC");
    }
  }
);

export const resendPocApprovalMail = createAsyncThunk(
  "enterprise/resendPocApprovalMail",
  async (pocId, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/v1/enterprise/poc/${pocId}/resend-approval-mail`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to resend approval email");
    }
  }
);

export const updatePocApprovalStatus = createAsyncThunk(
  "enterprise/updatePocApprovalStatus",
  async (
    { pocId, approvalStatus, rejectionReason, remarks },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.patch(
        `/api/admin/v1/enterprise/poc/${pocId}/approval-status`,
        {
          approvalStatus,
          rejectionReason,
          remarks,
        }
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to update POC approval status");
    }
  }
);

export const enterpriseSlice = createSlice({
  name: "enterprise",
  initialState: {
    loading: false,
    error: "",
    enterpriseList: [],
    newEntSubmitLoading: false,
    commentSubmitLoading: false,
    commentSubmitError: "",
    approveEntLoading: false,
    approveData: [],
    panLoading: false,
    gstinLoading: false,
    panError: "",
    gstinError: "",
    approveSubmitLoading: false,
    verifyDocLoading: false,
    verifyDocError: "",
    entDetailedData: {},
    tagsData: [],
    designationsData: [],
    reUploadError: "",
    editEntSaveLoading: false,
    editError: "",
    ratingData: {},
    statesData: [],
    pocsList: [],
    pocsLoading: false,
    pocsPagination: { totalRecords: 0, page: 1, limit: 10, totalPages: 1 },
    pocActionLoading: false,
    pocError: "",
  },

  extraReducers: (builder) => {
    builder.addCase(getEnterpriseView.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getEnterpriseView.fulfilled, (state, action) => {
      state.loading = false;
      state.enterpriseList = action.payload;
    });
    builder.addCase(getEnterpriseView.rejected, (state, action) => {
      state.loading = false;
      state.enterpriseList = [];
      state.error = action.payload;
    });

    builder.addCase(addNewEnterprise.pending, (state) => {
      state.newEntSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(addNewEnterprise.fulfilled, (state, action) => {
      state.newEntSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(addNewEnterprise.rejected, (state, action) => {
      state.newEntSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(entDocs.pending, (state) => {
      state.newEntSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(entDocs.fulfilled, (state, action) => {
      state.newEntSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(entDocs.rejected, (state, action) => {
      state.newEntSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(financialDocUpload.pending, (state) => {
      state.newEntLoading = true;
      state.error = "";
    });
    builder.addCase(financialDocUpload.fulfilled, (state, action) => {
      state.newEntLoading = false;
      state.error = "";
    });
    builder.addCase(financialDocUpload.rejected, (state, action) => {
      state.newEntLoading = false;
      state.error = action.payload;
    });

    builder.addCase(deactivateEnt.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(deactivateEnt.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(deactivateEnt.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(activateEnt.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(activateEnt.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(activateEnt.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(getApproveEnt.pending, (state) => {
      state.approveEntLoading = true;
      state.error = "";
    });
    builder.addCase(getApproveEnt.fulfilled, (state, action) => {
      state.approveEntLoading = false;
      state.approveData = action.payload;
    });
    builder.addCase(getApproveEnt.rejected, (state, action) => {
      state.approveEntLoading = false;
    });

    builder.addCase(blacklistEnt.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(blacklistEnt.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(blacklistEnt.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(verifyEntPan.pending, (state) => {
      state.panLoading = true;
      state.panError = "";
    });
    builder.addCase(verifyEntPan.fulfilled, (state, action) => {
      state.panLoading = false;
      state.panError = "";
    });
    builder.addCase(verifyEntPan.rejected, (state, action) => {
      state.panLoading = false;
      state.panError = action.payload;
    });

    builder.addCase(verifyEntGstin.pending, (state) => {
      state.gstinLoading = true;
      state.gstinError = "";
    });
    builder.addCase(verifyEntGstin.fulfilled, (state, action) => {
      state.gstinLoading = false;
      state.gstinError = "";
    });
    builder.addCase(verifyEntGstin.rejected, (state, action) => {
      state.gstinLoading = false;
      state.gstinError = action.payload;
    });

    builder.addCase(approveEnt.pending, (state) => {
      state.approveSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(approveEnt.fulfilled, (state, action) => {
      state.approveSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(approveEnt.rejected, (state, action) => {
      state.approveSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(verifyDoc.pending, (state) => {
      state.verifyDocLoading = true;
      state.verifyDocError = "";
    });
    builder.addCase(verifyDoc.fulfilled, (state, action) => {
      state.verifyDocLoading = false;
      state.verifyDocError = "";
    });
    builder.addCase(verifyDoc.rejected, (state, action) => {
      state.verifyDocLoading = false;
      state.verifyDocError = action.payload;
    });

    builder.addCase(rejectDoc.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(rejectDoc.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(rejectDoc.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(reUploadEntDocs.pending, (state) => {
      state.reUploadError = "";
    });
    builder.addCase(reUploadEntDocs.fulfilled, (state, action) => {
      state.reUploadError = "";
    });
    builder.addCase(reUploadEntDocs.rejected, (state, action) => {
      state.reUploadError = action.payload;
    });

    builder.addCase(entDetailedView.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(entDetailedView.fulfilled, (state, action) => {
      state.loading = false;
      state.entDetailedData = action.payload;
    });
    builder.addCase(entDetailedView.rejected, (state, action) => {
      state.loading = false;
      state.entDetailedData = {};
      state.error = action.payload;
    });

    builder.addCase(getTags.fulfilled, (state, action) => {
      state.tagsData = action.payload;
    });

    builder.addCase(getDesignations.fulfilled, (state, action) => {
      state.designationsData = action.payload;
    });

    builder.addCase(editEntDets.pending, (state) => {
      state.editEntSaveLoading = true;
      state.editError = "";
    });
    builder.addCase(editEntDets.fulfilled, (state, action) => {
      state.editEntSaveLoading = false;
      state.editError = "";
    });
    builder.addCase(editEntDets.rejected, (state, action) => {
      state.editEntSaveLoading = false;
      state.editError = action.payload;
    });

    builder.addCase(getAllRating.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllRating.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      state.ratingData = action.payload;
    });
    builder.addCase(getAllRating.rejected, (state, action) => {
      state.loading = false;
      state.ratingData = {};
      state.error = action.payload;
    });

    builder.addCase(getAllStates.fulfilled, (state, action) => {
      state.statesData = action.payload;
    });

    // POC Library Cases
    builder.addCase(getEnterprisePocs.pending, (state) => {
      state.pocsLoading = true;
      state.pocError = "";
    });
    builder.addCase(getEnterprisePocs.fulfilled, (state, action) => {
      state.pocsLoading = false;
      const data = action.payload?.data || action.payload || {};
      state.pocsList = data?.pocs || [];
      state.pocsPagination = {
        totalRecords: data?.totalRecords || 0,
        page: data?.page || 1,
        limit: data?.limit || 10,
        totalPages: data?.totalPages || 1,
      };
    });
    builder.addCase(getEnterprisePocs.rejected, (state, action) => {
      state.pocsLoading = false;
      state.pocsList = [];
      state.pocError = action.payload;
    });

    builder.addCase(addEnterprisePoc.pending, (state) => {
      state.pocActionLoading = true;
      state.pocError = "";
    });
    builder.addCase(addEnterprisePoc.fulfilled, (state) => {
      state.pocActionLoading = false;
    });
    builder.addCase(addEnterprisePoc.rejected, (state, action) => {
      state.pocActionLoading = false;
      state.pocError = action.payload;
    });

    builder.addCase(updateEnterprisePoc.pending, (state) => {
      state.pocActionLoading = true;
      state.pocError = "";
    });
    builder.addCase(updateEnterprisePoc.fulfilled, (state) => {
      state.pocActionLoading = false;
    });
    builder.addCase(updateEnterprisePoc.rejected, (state, action) => {
      state.pocActionLoading = false;
      state.pocError = action.payload;
    });

    builder.addCase(deleteEnterprisePoc.pending, (state) => {
      state.pocActionLoading = true;
      state.pocError = "";
    });
    builder.addCase(deleteEnterprisePoc.fulfilled, (state) => {
      state.pocActionLoading = false;
    });
    builder.addCase(deleteEnterprisePoc.rejected, (state, action) => {
      state.pocActionLoading = false;
      state.pocError = action.payload;
    });

    builder.addCase(resendPocApprovalMail.pending, (state) => {
      state.pocActionLoading = true;
      state.pocError = "";
    });
    builder.addCase(resendPocApprovalMail.fulfilled, (state) => {
      state.pocActionLoading = false;
    });
    builder.addCase(resendPocApprovalMail.rejected, (state, action) => {
      state.pocActionLoading = false;
      state.pocError = action.payload;
    });

    builder.addCase(updatePocApprovalStatus.pending, (state) => {
      state.pocActionLoading = true;
      state.pocError = "";
    });
    builder.addCase(updatePocApprovalStatus.fulfilled, (state) => {
      state.pocActionLoading = false;
    });
    builder.addCase(updatePocApprovalStatus.rejected, (state, action) => {
      state.pocActionLoading = false;
      state.pocError = action.payload;
    });
  },

  reducers: {
    updateErrorStatus(state) {
      state.error = "";
      state.commentSubmitError = "";
      state.editError = "";
      state.panError = "";
      state.gstinError = "";
      state.pocError = "";
    },
  },
});

export const { updateErrorStatus } = enterpriseSlice.actions;

export default enterpriseSlice.reducer;
